module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-desktop-ce660425b5a6a2a3c0124ee4b11c4d10.jpg";